module.exports = __webpack_public_path__ + "static/media/video1.ea032f14.mp4";